import PaymentsConfirmationPanel from './PaymentsConfirmationPanel';

export default PaymentsConfirmationPanel;
